//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'
import 'devextreme/ui/scroll_view'

//#endregion

//#region Service Imports

import { ReferenceTypeService, REFERENCE_TYPE_SERVICE_NAME } from '../../../services/reference-type'
import { GridService, GRID_SERVICE_NAME } from '../../../services/grid'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { DistributorHierarchyService, DISTRIBUTOR_HIERARCHY_SERVICE_NAME } from '../../../services/distributor'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { ColumnModel, EntityModel, GridRequestReferenceModel } from '../../api/api.models'

//#region Model Imports

import { Enums } from '../../../models/common/enums'
import { ColumnInfo } from '../../../models/custom'

//#endregion

import { CommonHelper, Md5, TypeHelper, ReferenceTypeComponent, LocalizationHelper, TemplateHelper, ConfigHelper, ConvertHelper } from '../../../helpers/'

import { GridOptions, GridTypes } from '../grid/grid.controller'
import { TreeListOptions } from '../tree-list/tree-list.controller'
import { i18n } from '../i18n/common.i18n'

//#region Assets Imports

import './select-popover.scss'
import * as TEMPLATE from './select-popover.tpl.html'

//#endregion

class SelectedData {
    protected _name = null

    get name() {
        return this._name != null ? this._name : i18n('Popup', 'LocationNothingSelected')
    }

    set name(str) {
        if (str)
            if (str.trim() == '')
                this._name = 'no name'
            else
                this._name = str
        else
            this._name = str
    }
}

export interface Source {
    dictionaryMethod: string
    dataIdSourceModule?: Enums.WebSimaxModule
}

export type SelectPopoverOptions = {
    referenceTypeId: number,
    showClearButton?: boolean,
}

export interface SelectPopoverMultySelectionSource {
    myltySelection: boolean
    selectedIds: number[]
    columns?: any
    staticSource: any[]
    referenceTypeId?: number
    dictionaryMethod: string
    visible: boolean,
    clearSelection?: boolean,
    isKPI?: boolean
    saveName: string
}

interface SelectScope extends ng.IScope {
    popoverOptions: DevExpress.ui.dxPopoverOptions
    popoverVisible: boolean
    hidePopover(): void
    gridOptions: GridOptions
    grid: DevExpress.ui.dxDataGrid
    columnsCount: number
    selectedId: number
    selectedValue?: any
    datatypeId: number
    referenceTypeId: number
    selected: SelectedData
    options: SelectPopoverOptions
    clearSelection: () => void
    source: Source
    popoverId: number
    scriptArg: any
    isLoading: boolean
    id: number
    showPopover: () => void
    showClearButton: () => boolean

    multySelectionSource: SelectPopoverMultySelectionSource
    selectedData?: any[]

    selectButtonOptions: DevExpress.ui.dxButtonOptions
    submitButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonOptions: DevExpress.ui.dxButtonOptions

    treeListOptions: TreeListOptions
}

export class SelectPopoverDirective implements ng.IDirective {
    previousLocationMd5: string

    scope = {
        'callback': '&callback',
        selectedId: '=',
        selectedValue: '=?',
        selectedData: '=?',
        datatypeId: '=?',
        referenceTypeId: '=?',
        source: '=?',
        options: '=?',
        scriptArg: '@?',
        id: '=?',
        multySelectionSource: '=?'
    }
    restrict = 'E'

    treeList: any
    treeListId: number

    controller = ['$scope', '$q', '$timeout', 'localDictionary', 'api',
        GRID_SERVICE_NAME,
        DISTRIBUTOR_HIERARCHY_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME, (
            $scope: SelectScope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            localDictionary: LocalDictionaryFactory,
            api: Api,
            gridService: GridService,
            distributorHierarchyService: DistributorHierarchyService,
            userSession: UserSessionService,
            referenceTypeService: ReferenceTypeService
        ) => {
            $scope.popoverId = new Date().getTime()
            $scope.popoverVisible = false
            $scope.popoverOptions = {
                width: 800,
                height: 500,
                target: '#selectPopover' + $scope.popoverId,
                bindingOptions: {
                    visible: 'popoverVisible'
                },
                onHiding: () => {
                    $scope.popoverVisible = false
                    if ($scope.grid) {
                        $scope.grid.clearFilter()
                    }
                    if ($scope.multySelectionSource && $scope.multySelectionSource.clearSelection) {
                        $scope.clearSelection()
                    }
                },
                onShowing: e => {
                    this.previousLocationMd5 = ""
                }
            }
            if (!$scope.source)
                $scope.source = {
                    dictionaryMethod: 'getLocationSelectColumns'
                }

            $scope.selected = new SelectedData

            var getMessageFromMultipleData = (data: any[]) => {
                var message = ''
                if (data.length > 0) {
                    message = '(' + data.length + ') ' + data.map(d => d['name']).join(', ')
                }
                return message
            }

            if ($scope.selectedValue) {
                $scope.selected.name = $scope.selectedValue
            } else if ($scope.selectedId && ($scope.options == null || $scope.options.referenceTypeId == null)) {
                var request = new EntityModel()
                request.referenceId = $scope.referenceTypeId
                request.id = $scope.selectedId
                api.app.getReferenceObject(request).then(result => {
                    if (result) {
                        $scope.selected.name = result['name']
                        $scope['callback']()($scope.selectedId)
                    }
                })
            } else if ($scope.multySelectionSource && $scope.selectedData != undefined && $scope.selectedData.length >= 0) {
                $timeout(() => {
                    var message = getMessageFromMultipleData($scope.selectedData)
                    if (message != '') {
                        $scope.selected.name = message
                    }
                })
            } else if ($scope.options != null && $scope.options.referenceTypeId != null && $scope.selectedId) {
                referenceTypeService
                    .getReferenceObjects($scope.options.referenceTypeId, {
                        referenceValues: [$scope.selectedId]
                    })
                    .then(result => {
                        if (_.size(result.objects) > 0) {
                            $scope.selected.name = _.first(result.objects).toString()
                            $scope['callback']()($scope.selectedId)
                        }
                    })
            }

            var showPopover = () => {
                $scope.popoverVisible = !$scope.popoverVisible
                drawGrid().then((grid: DevExpress.ui.dxDataGrid) => {
                    if ($scope.multySelectionSource && $scope.multySelectionSource.selectedIds.length > 0) {
                        $timeout(() => {
                            grid.selectRows($scope.multySelectionSource.selectedIds, false)
                            grid.getDataSource().on('changed', () => { grid.selectRows($scope.multySelectionSource.selectedIds, false) })

                        })
                    }
                })
            }

            $scope.showPopover = () => showPopover()

            $scope.hidePopover = () => {
                $scope.popoverVisible = false
            }

            $scope.isLoading = true

            var getData = (request: GridRequestReferenceModel, columns: ColumnModel[] = null) => {
                $scope.$root.$broadcast('disableLoadingIndicator')

                if (columns && columns.length > 0 && request.where && request.where.length > 0) {
                    return localDictionary.getReferenceTable(request.idReferenceType, $scope.datatypeId, request.pageNumber, request.pageSize, request.columns, request.where, true).then(result => {
                        return result.gridData
                    }).finally(() => {
                        $scope.$root.$broadcast('enableLoadingIndicator')
                        $scope.isLoading = false
                    })
                }
                else {
                    return localDictionary.getReferenceTable(request.idReferenceType, $scope.datatypeId, request.pageNumber, request.pageSize, request.columns, '', true).then(result => {
                        return result.gridData
                    }).finally(() => {
                        $scope.$root.$broadcast('enableLoadingIndicator')
                        $scope.isLoading = false
                    })
                }
            }

            $scope.$watch('selectedId', (value) => {
                if (!value)
                    $scope.selected.name = i18n('Popup', 'LocationNothingSelected')
            })

            $scope.$watch('multySelectionSource.selectedIds', () => {
                if ($scope.multySelectionSource && $scope.multySelectionSource.selectedIds.length > 0) {
                    var message = ''
                    $scope.multySelectionSource.staticSource.forEach(data => {
                        if ($scope.multySelectionSource.selectedIds.indexOf(data.id) > -1) {
                            if (message) message += ', '
                            message += data.name
                        }
                    })
                    message = '(' + $scope.multySelectionSource.selectedIds.length + ') ' + message
                    if ($scope.selectedData) message = getMessageFromMultipleData($scope.selectedData)
                    $scope.selected.name = message
                }
            })

            $scope.$watch('options.referenceTypeId', (value) => {
                if ($scope.grid) {
                    $scope.grid = null
                    $scope.gridOptions = null
                    $scope.selectedId = null
                    drawGrid()
                }
            })

            const getModuleName = (moduleId: Enums.SimaxModuleName): string => {
                let moduleName: string
                TypeHelper.iterateEnum(Enums.SimaxModuleName, (key: Enums.SimaxModuleName, name: string) => {
                    if (key == moduleId) {
                        moduleName = name
                    }
                })
                return moduleName
            }

            const drawGrid = (): angular.IPromise<{}> => {
                const defer: angular.IDeferred<{}> = $q.defer()

                if ($scope.options != null && $scope.options.referenceTypeId != null) {
                    const referenceId: Enums.ReferenceType = <Enums.ReferenceType>ConvertHelper.parseEnum(Enums.ReferenceType, $scope.options.referenceTypeId)
                    const moduleName: Enums.SimaxModuleName = ReferenceTypeComponent.getModuleByReferenceType(referenceId)

                    $
                        .when<any>(
                            gridService.getPopupColumnModelByReferenceType(referenceId),
                            distributorHierarchyService.isDistributorHierarchyEnabled()
                        )
                        .then((columns: ColumnModel[], isDistributorHierarchyEnabled: boolean) => {
                            if (columns != null && columns.length > 0) {
                                if (referenceId === Enums.ReferenceType.IdDistributor && isDistributorHierarchyEnabled) {

                                    distributorHierarchyService
                                        .getTreeListDataSource(columns)
                                        .then((treeData: any[]) => {
                                            $scope.treeListOptions = {
                                                addCustomFilters: true,
                                                columnsDictionary: columns,
                                                dataSource: new DataSource(treeData),
                                                keyExpr: 'idDistributorHierarchy',
                                                name: 'distributorHierarchyTreeList',
                                                parentIdExpr: 'idDistributorHierarchyParent',
                                                referenceId: Enums.ReferenceType.IdDistributor,
                                                type: GridTypes.MAIN,

                                                buttonsOptions: {
                                                    enabled: true
                                                },

                                                onInitialized: e => {
                                                    this.treeListId = e.tableId
                                                    this.treeList = e.component
                                                    $scope.isLoading = false
                                                    defer.resolve()
                                                },

                                                onRowDoubleClick: e => {
                                                    selectLocation()
                                                },
                                            }
                                        })
                                }
                                else {
                                    $scope.gridOptions = {
                                        columnsDictionary: columns,
                                        name: getModuleName(moduleName) + '_Select_Popover',
                                        type: GridTypes.PAGINATED_SMALL,

                                        buttonsOptions: {
                                            enabled: true
                                        },

                                        getDataSourceMethod: (columns: ColumnInfo[], pageNumber: number, pageSize: number, customWhereClause: string): any => {
                                            if ($scope.source != null) {
                                                const webSimaxModule: Enums.WebSimaxModule = ConvertHelper.parseEnum<Enums.WebSimaxModule>(Enums.WebSimaxModule, $scope.source.dataIdSourceModule)
                                                
                                                if (webSimaxModule != null && webSimaxModule != Enums.WebSimaxModule.Unknown) {
                                                    return ReferenceTypeComponent.getFilterItemsByWebSimaxModule(userSession.getDataProvider(), webSimaxModule, columns, pageNumber, pageSize, customWhereClause)
                                                }
                                            }

                                            return referenceTypeService.getReferenceObjects(referenceId, {
                                                filterOptions: {
                                                    columns,
                                                    customWhereClause
                                                },
                                                pagingOptions: {
                                                    pageNumber,
                                                    pageSize
                                                },
                                                contextIdDataType: $scope.datatypeId
                                            });
                                        },

                                        onInitialized: (e: any) => {
                                            $scope.grid = e.component
                                            $scope.isLoading = false
                                            defer.resolve($scope.grid)
                                        },

                                        onRowDoubleClick: (e: any) => {
                                            selectLocation()
                                        }
                                    }
                                }
                            }
                        })
                }
                else if ($scope.multySelectionSource) {
                    localDictionary[$scope.multySelectionSource.dictionaryMethod]().then(columns => {
                        if ($scope.multySelectionSource.columns != null && $scope.multySelectionSource.columns.length > 0) {
                            columns = $scope.multySelectionSource.columns
                        }

                        if ($scope.grid) {
                            defer.resolve($scope.grid)
                        }

                        $scope.gridOptions = {
                            name: 'select' + $scope.multySelectionSource.saveName,
                            type: GridTypes.PAGINATED_SMALL,
                            columnAutoWidth: true,
                            buttonsOptions: {
                                enabled: true
                            },
                            onInitialized: e => {
                                $scope.grid = e.component
                                $scope.isLoading = false
                                defer.resolve($scope.grid)
                            },
                            columnsDictionary: columns,
                            selection: {
                                mode: "multiple",
                                deferred: !$scope.multySelectionSource.referenceTypeId ? true : false,
                                showCheckBoxesMode: 'always',
                                allowSelectAll: true,
                                selectAllMode: 'allPages'
                            },
                            hideHeaderCheckbox: $scope.multySelectionSource.referenceTypeId ? true : false
                        }

                        if (!$scope.multySelectionSource.referenceTypeId) {
                            $scope.gridOptions.dataSource = new DataSource($scope.multySelectionSource.staticSource)
                        } else {
                            localDictionary.getActiveViewColumnsForReferenceType($scope.multySelectionSource.referenceTypeId).then(columnsForWhere => {
                                $scope.gridOptions.request = request => {
                                    request.columns = columnsForWhere
                                    request.idReferenceType = $scope.multySelectionSource.referenceTypeId
                                    if ($scope.multySelectionSource.isKPI && $scope.multySelectionSource.referenceTypeId == CommonHelper.IdLocation) return getLocations(request)
                                    else if ($scope.multySelectionSource.isKPI && $scope.multySelectionSource.referenceTypeId == CommonHelper.IdMeter) return getMeters(request)
                                    else return getData(request, columnsForWhere)
                                }
                                $scope.gridOptions.columnsDictionary = columnsForWhere
                                $scope.gridOptions.referenceId = $scope.multySelectionSource.referenceTypeId
                            })
                        }

                    })
                }

                return defer.promise
            }

            const selectLocation = () => {
                let selectedRowData: any[] = null

                if ($scope.grid) {
                    selectedRowData = $scope.grid.getSelectedRowsData()
                }
                else if (this.treeList) {
                    selectedRowData = this.treeList.getSelectedRowsData()
                }

                if (selectedRowData && selectedRowData.length > 0) {
                    $scope.selected.name = selectedRowData[0]['name']

                    const currentMd5 = Md5.init({
                        id: selectedRowData[0]['id'],
                        datatypeId: $scope.datatypeId,
                        name: $scope.selected.name,
                        scriptArg: $scope.scriptArg
                    })

                    if (this.previousLocationMd5 !== currentMd5) {
                        $scope['callback']()(selectedRowData[0]['id'], $scope.datatypeId, $scope.selected.name, $scope.scriptArg, selectedRowData[0])
                        this.previousLocationMd5 = currentMd5
                    }
                }

                $scope.hidePopover()
            }

            var multipleSelection = () => {
                var selectedRowData = $scope.grid.getSelectedRowsData()
                $scope.selected.name = ''

                if (selectedRowData.then) {
                    selectedRowData.then(selectedData => {
                        var message = getMessageFromMultipleData(selectedData)
                        if (message != '')
                            $scope.selected.name = message
                        $scope['callback']()(selectedData, message)
                    })
                } else {
                    var message = getMessageFromMultipleData(selectedRowData)
                    if (message != '')
                        $scope.selected.name = message
                    $scope['callback']()(selectedRowData, message)
                }

                $scope.hidePopover()
            }

            var cancel = () => {
                $scope.hidePopover()
            }

            $scope.clearSelection = () => {
                $scope.selected.name = null
                var param = null
                if ($scope.multySelectionSource) {
                    $scope.multySelectionSource.selectedIds = []
                    if ($scope.grid) $scope.grid.clearSelection()
                    param = []
                }
                $scope['callback']()(param, $scope.datatypeId, $scope.selected.name, $scope.scriptArg, this)
            }

            $scope.selectButtonOptions = {
                template: TemplateHelper.getIcon(ConfigHelper.Icon.HEADLINE, userSession),
                hint: i18n('Popup', 'Select'),
                onClick: showPopover
            }

            $scope.submitButtonOptions = {
                text: i18n('Common', 'Submit'),
                onClick: () => {
                    if ($scope.multySelectionSource) multipleSelection()
                    else selectLocation()
                }
            }

            $scope.cancelButtonOptions = {
                text: i18n('Common', 'Cancel'),
                onClick: cancel
            }

            var getLocations = (request: GridRequestReferenceModel) => {
                $scope.$root.$broadcast('disableLoadingIndicator')
                return api.kpi.getLocations(request).then(result => {
                    $scope.$root.$broadcast('enableLoadingIndicator')
                    return result
                })
            }

            var getMeters = (request: GridRequestReferenceModel) => {
                $scope.$root.$broadcast('disableLoadingIndicator')
                return api.kpi.getMeters(request).then(result => {
                    $scope.$root.$broadcast('enableLoadingIndicator')
                    return result
                })
            }

            $scope.showClearButton = (): boolean => {
                const isNothingSelected: boolean = $scope.selected.name == LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NothingSelected)

                if ($scope.options != null && $scope.options.showClearButton != null) {
                    return $scope.options.showClearButton && !isNothingSelected
                } else {
                    //backward capability
                    return !isNothingSelected
                }
            }
        }]
    template = TEMPLATE
    replace = true
}